import { defineMessages } from 'react-intl';
import brandSignal1Icon from './assets/trustSignals/ic_art.svg';
import brandSignal3Icon from './assets/trustSignals/ic_leaf.svg';
import brandSignal2Icon from './assets/trustSignals/ic_thumbs-up.svg';

const brandSignalsMessages = defineMessages({
  brandSignal1Title: {
    defaultMessage: 'Weirdly meaningful art',
    description: 'The first brand messaging point title.',
  },
  brandSignal1: {
    defaultMessage: 'Millions of designs on over 70 high quality products.',
    description: 'The first brand messaging point message.',
  },
  brandSignal2Title: {
    defaultMessage: 'Purchases pay artists',
    description: 'The 2nd brand messaging point title.',
  },
  brandSignal2: {
    defaultMessage: "Money goes directly into a creative person's pocket.",
    description: 'The 2nd brand messaging point message.',
  },
  brandSignal3Title: {
    defaultMessage: 'Socially responsible production',
    description: 'The 3rd brand messaging point title.',
  },
  brandSignal3: {
    defaultMessage:
      "We're investing in programs to offset all carbon emissions.",
    description: 'The 3rd brand messaging point message.',
  },
});

const brandSignalsData = [
  {
    key: 'brandSignal1',
    imageUrl: brandSignal1Icon,
    title: brandSignalsMessages.brandSignal1Title,
    text: brandSignalsMessages.brandSignal1,
  },
  {
    key: 'brandSignal2',
    imageUrl: brandSignal2Icon,
    title: brandSignalsMessages.brandSignal2Title,
    text: brandSignalsMessages.brandSignal2,
  },
  {
    key: 'brandSignal3',
    imageUrl: brandSignal3Icon,
    title: brandSignalsMessages.brandSignal3Title,
    text: brandSignalsMessages.brandSignal3,
  },
];

export { brandSignalsMessages, brandSignalsData };
